<mat-card>
  <h2 mat-dialog-title>{{ dialogData?.title }}</h2>
  <mat-card-content class="cardWithShadow">
    <form [formGroup]="dishForm">
      <div formGroupName="dish">
        <div style="display: flex; flex-direction: column">
          <mat-form-field appearance="outline">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              placeholder="Nombre"
              formControlName="nombre"
              name="nombre"
              required
            />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Categoría</mat-label>
            <input
              matInput
              placeholder="Categoría"
              formControlName="categoria"
              name="categoria"
            />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Observaciones</mat-label>
            <textarea
              matInput
              placeholder="Observaciones"
              formControlName="observaciones"
              name="observaciones"
              cols="40"
              rows="5"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <mat-dialog-actions>
        <button mat-raised-button mat-dialog-close>Cancelar</button>
        <button
          mat-raised-button
          *ngIf="dialogData.estado == 1"
          color="primary"
          (click)="updateDish()"
        >
          {{ dialogData.title }}
        </button>
        <button
          mat-raised-button
          color="primary"
          *ngIf="dialogData.estado == 2"
          (click)="createPlato()"
        >
          {{ dialogData.title }}
        </button>
      </mat-dialog-actions>
    </form>
  </mat-card-content>
</mat-card>
